
import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../actions/loginActions';
import * as clauseActions from '../../actions/clauseActions';
import {
    Grid,
    Row,
    Col,
    FormGroup,
    FormControl,
    ControlLabel,
    Image
} from "react-bootstrap";
//import "react-select/dist/react-select.css";
import Card from "../../components/Card/Card.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from "../../components/CustomButton/CustomButton.jsx";
import ReactDOM from "react-dom";
import rest from "../../API/api";

class ClauseForm extends Component {
    constructor(props) {
        super(props);
        this._grabUserInput = this._grabUserInput.bind(this);
        this._readClause = this._readClause.bind(this);
        this._saveClause = this._saveClause.bind(this);
        this.isValidated = this.isValidated.bind(this);
        this.handleRequiredChange = this.handleRequiredChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.state = {
            Type: this.props.clause.Type,
            Required:  this.props.clause.Required,
            Title: this.props.clause.Title,
            Text: this.props.clause.Text,
            TypeError: null,
            RequiredError: null,
            TitleError: null,
            TextError: null
        };
        this._readClause(this.props.id);
    }
    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }

_readClause(id){
    let tempURL = rest.clause + '/' + id;
    fetch(tempURL, {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json;charset=UTF-8',
            'x-api-key': this.props.userLoggedIn[0].apiKey
        })
    })
        .then(response => response.json())
        .then(data => {
            //debugger;
            this.setState({
                _id: data._id,
                Type: data.Type,
                Required:  data.Required,
                Title: data.Title,
                Text:data.Text
            });
            return (data);
        })
        .catch(error => console.error(error));

}
    isValidated() {
        //check each required field for validation
        this.state.Type === ""
            ? this.setState({
                TypeError: (
                    <small className="text-danger">
                        Please provide a Type for this consent clause.
                    </small>
                )
            })
            : this.setState({ TypeError: null });
        var type = this.state.Type !== "";

        this.state.Type === "Type of Consent?"
            ? this.setState({
                TypeError: (
                    <small className="text-danger">
                        Please provide a Type for this consent clause.
                    </small>
                )
            })
            : this.setState({ TypeError: null });
        var type2 = this.state.Type !== "Type of Consent?";

        this.state.Required === ""
            ? this.setState({
                RequiredError: (
                    <small className="text-danger">
                        Please choose if this clause is required for consent confirmation.
                    </small>
                )
            })
            : this.setState({ RequiredError: null });
        var required = this.state.Required !== "";

        this.state.Required === "Consent Required?"
            ? this.setState({
                RequiredError: (
                    <small className="text-danger">
                        Please choose if this clause is required for consent confirmation.
                    </small>
                )
            })
            : this.setState({ RequiredError: null });
        var required2 = this.state.Required !== "Consent Required?";

        this.state.Title === ""
            ? this.setState({
                TitleError: (
                    <small className="text-danger">
                        Please provide a title for this consent clause.
                    </small>
                )
            })
            : this.setState({ TitleError: null });
        var title = this.state.Title !== "";

        this.state.Text === ""
            ? this.setState({
                TextError: (
                    <small className="text-danger">
                        Please provide the text for this consent clause.
                    </small>
                )
            })
            : this.setState({ TextError: null });
        var text = this.state.Text !== "";

        var valid = (type && required && title && text && required2 && type2);
        if(valid)
            return valid;
    }


    successAlert(saved){
        //Setup the alert and use the context to route to the Tenants once record is saved.
        if(saved) {
            this.setState({
                alert: (
                    <SweetAlert
                        success
                        title="Consent clause updated successfully!"
                        style={{display: "block"}}
                        onConfirm={() => this.context.router.history.push("/Clauses")}
                        onCancel={() => this.context.router.history.push("/Clauses")}
                        confirmBtnBsStyle="info"
                    >
                    </SweetAlert>
                )
            });
        }
        else
        {
            this.setState({
                alert: (
                    <SweetAlert
                        danger
                        style={{display: "block"}}
                        title="Error updating this consent clause record, Please try again!"
                        onConfirm={() => this.setState({alert: null})}
                        onCancel={() => this.setState({alert: null})}
                        confirmBtnBsStyle="danger"
                    >
                    </SweetAlert>
                )
            });
        }
    }

    _grabUserInput() {
        return {
            _id: this.props.id,
            Type: ReactDOM.findDOMNode(this.selectType).value,
            Required: ReactDOM.findDOMNode(this.selectRequired).value,
            Title: document.getElementById('Title').value,
            Text: document.getElementById('Text').value,
        };
    }

    _saveClause(event) {
        event.preventDefault();
        if (this.isValidated()) {
            let userInput = this._grabUserInput();
            //Pass the current logged in user information and the new clause record array
            this.props.clauseActions.updateClause(this.props.userLoggedIn[0],userInput);
            this.successAlert(true);
        }

    }

    handleRequiredChange= () => {
        //console.log(ReactDOM.findDOMNode(this.select).value);
        this.setState({ Required: ReactDOM.findDOMNode(this.selectRequired).value });
    };

    handleTypeChange= () => {
        //console.log(ReactDOM.findDOMNode(this.select).value);
        this.setState({ Type: ReactDOM.findDOMNode(this.selectType).value });
    };

    render() {
        //debugger;
        if ((this.props.userLoggedIn[0].status) && (this.props.userLoggedIn[0].subscription)) {
            return (
                <div className="main-content" style={{ backgroundImage: "url(" + require("../../assets/img/matrix.jpg") + ")" }}>
                    <Grid fluid>
                        <Card
                            content={
                                <div>
                                    <legend>Update: Consent Clause Information</legend>
                                    <Row>
                                        <Col md={5} mdOffset={1}>
                                            <FormGroup>
                                                <ControlLabel>Clause Title <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Title"
                                                    type="text"
                                                    name="title"
                                                    placeholder="ex: MyClause Title"
                                                    value={this.state.Title}
                                                    onChange={event => this.setState({Title: event.target.value})}
                                                />
                                                {this.state.TitleError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                            <FormGroup>
                                                <ControlLabel>Consent Required? <span className="text-danger">*</span></ControlLabel>
                                                <FormControl componentClass="select"
                                                             placeholder="Consent Required?"
                                                             ref={select => { this.selectRequired = select }}
                                                             onChange={this.handleRequiredChange}
                                                             value={this.state.Required}
                                                >
                                                    <option value="Consent Required?">Consent Required?</option>
                                                    <option value="Required">Required</option>
                                                    <option value="Not Required">Not Required</option>
                                                </FormControl>
                                                {this.state.RequiredError}
                                            </FormGroup>
                                        </Col>
                                        <Col md={3}>
                                            <FormGroup>
                                                <ControlLabel>Type of Consent <span className="text-danger">*</span></ControlLabel>
                                                <FormControl componentClass="select"
                                                             placeholder="Type of Consent?"
                                                             ref={select => { this.selectType = select }}
                                                             onChange={this.handleTypeChange}
                                                             value={this.state.Type}
                                                >
                                                    <option value="Type of Consent?">Type of Consent?</option>
                                                    <option value="Checkbox">Checkbox</option>
                                                    <option value="Yes/No">Yes/No</option>
                                                </FormControl>
                                                {this.state.TypeError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={5} mdOffset={1} >
                                            <FormGroup>
                                                <ControlLabel>Consent Clause Text <span className="text-danger">*</span></ControlLabel>
                                                <FormControl
                                                    id="Text"
                                                    componentClass="textarea"
                                                    rows="5"
                                                    name="text"
                                                    placeholder="Consent Clause text..."
                                                    value={this.state.Text}
                                                    onChange={event => this.setState({Text: event.target.value})}
                                                />
                                                {this.state.TextError}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={5} mdOffset={1} xs={5} xsOffset={1}>
                                            <Button bsStyle="info" pullRight fill wd onClick={this._saveClause}>
                                                Save
                                            </Button>
                                        </Col>
                                        <Col md={1} mdOffset={1} xs={5} xsOffset={1}>
                                            <Button bsStyle="info" pullRight fill wd onClick={ async () => {
                                                let tURL = "/clauses";
                                                await this.context.router.history.push(tURL);
                                            }}>
                                                Cancel
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            }
                        />
                        {this.state.alert}
                    </Grid>
                </div>
            );
        }
        else {
            alert("You must be logged in and have an active subscription to access this page!");
            this.context.router.history.push("/pages/login-page");
            return(null);
        }
    }
}


ClauseForm.propTypes = {
    loginActions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired,
    clause: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    const id = ownProps.match.params.id;  //from editclause/:id
    return {
        userLoggedIn: state.userLoggedIn,
        clause: state.clause,
        id: id
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
        clauseActions: bindActionCreators(clauseActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClauseForm);




// WEBPACK FOOTER //
// ./src/views/Forms/EditClause.jsx